<p-toast></p-toast>

<p-toolbar>
	<div class="ui-toolbar-group-left">
		<button pButton pRipple label="New" icon="pi pi-plus" class="p-button-success p-mr-2" (click)="openNew()"></button>
	</div>
</p-toolbar>

<div class="ui-g">
	<div class="ui-g-12">
		<div class="card no-margin">
			<h1>DataTable</h1>
			<p-table #dt [columns]="cols" styleClass="ui-table-cars"
					 [value]="templates"
					 [paginator]="true" [rows]="10" dataKey="id"
					 selectionMode="single" [(selection)]="selectedTemplate" (onRowSelect)="editTemplate(selectedTemplate)"
					 (onRowUnselect)="onRowUnselect($event)"
					 [totalRecords]="totalRecords"
					 [lazy]="true" (onLazyLoad)="loadTemplates($event)"
					 [loading]="loading">
				<ng-template pTemplate="caption">
					List of Templates
				</ng-template>
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngSwitch]="col.field">
							{{col.header}}
							<p-sortIcon [field]="col.field"></p-sortIcon>
						</th>
						<th style="width: 8em;">
						</th>
					</tr>
					<tr>
						<th *ngFor="let col of columns" [ngSwitch]="col.field" style="padding: .5em;">
							<input *ngSwitchCase="'id'" pInputText type="text" placeholder="Equals" class="ui-column-filter" style="width: 100%; margin-top: 0;" (input)="dt.filter($event.target.value, col.field, 'equals')">
							<input *ngSwitchCase="'iceSupplier'" pInputText type="text" placeholder="Contains" class="ui-column-filter" style="width: 100%; margin-top: 0;" (input)="dt.filter($event.target.value, col.field, 'contains')">
							<input *ngSwitchCase="'fiscalId'" pInputText type="text" placeholder="Contains" class="ui-column-filter" style="width: 100%; margin-top: 0;" (input)="dt.filter($event.target.value, col.field, 'contains')">
							<input *ngSwitchCase="'supplierName'" pInputText type="text" placeholder="Contains" class="ui-column-filter" style="width: 100%; margin-top: 0;" (input)="dt.filter($event.target.value, col.field, 'contains')">
							<input *ngSwitchCase="'vatIdNumber'" pInputText type="text" placeholder="Contains" class="ui-column-filter" style="width: 100%; margin-top: 0;" (input)="dt.filter($event.target.value, col.field, 'contains')">
						</th>
						<th style="width: 8em; text-align: center;">
							<button pButton type="button" icon="pi pi-cog"></button>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-rowData let-columns="columns">
					<tr [pSelectableRow]="rowData" [pEditableRow]="rowData">
						<td>{{rowData.id}}</td>
						<td>{{rowData.iceSupplier}}</td>
						<td>{{rowData.content | shorten:45}}</td>
						<td>{{rowData.supplierName}} </td>
						<td>{{rowData.fiscalId}}</td>
						<td>{{rowData.vatIdNumber}}</td>
						<td>
							<button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteTemplate(rowData)"></button>
						</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="summary">
					<div class="p-d-flex p-ai-center p-jc-between">
						In total there are {{ totalRecords }} templates.
					</div>
				</ng-template>
			</p-table>
		</div>
	</div>
</div>

<p-dialog [(visible)]="templateDialog" [style]="{width: '700px', height: '660px'}"  header="{{editMode?'Editing':'Adding'}} the Template" [modal]="true">
	<form [formGroup]="templateForm" (ngSubmit)="saveTemplate()" class="p-col-12">
		<div class="p-col-12">
			<div class="p-grid form-group">
				<div class="p-col-12 p-md-4" *ngIf="editMode">
					<div class="p-col-12"  >
						<label for="id">Id</label>
					</div>
					<div class="p-col-12" style="margin-bottom:10px" >
						<input id="id" type="text" pInputText placeholder="Id"  disabled  formControlName="id">
					</div>
				</div>
				<div class="p-col-12 p-md-4">
					<div class="p-col-12">
						<label for="iceSupplier">Supplier ICE</label>
					</div>
					<div class="p-col-12" style="margin-bottom:10px">
						<input type="text" id="iceSupplier" pInputText placeholder="Supplier ICE" formControlName="iceSupplier" autofocus>
					</div>
				</div>
				<div class="p-col-12 p-md-4">
					<div class="p-col-12">
						<label for="nameSupplier">Supplier Name</label>
					</div>
					<div class="p-col-12" style="margin-bottom:10px">
						<input type="text" id="nameSupplier" pInputText placeholder="Supplier Name"  formControlName="supplierName"  >
					</div>
					<div class="p-col-12" style="margin-bottom:10px">
						<small class="validation-error" *ngIf="supplierName.invalid && (supplierName.dirty || supplierName.touched)">Supplier Name is required.</small>
					</div>
				</div>
				<div class="p-col-12 p-md-4">
					<div class="p-col-12">
						<label for="fiscalId">Fiscal Id</label>
					</div>
					<div class="p-col-12" style="margin-bottom:10px">
						<input type="text" id="fiscalId" pInputText placeholder="Fiscal Id"  formControlName="fiscalId" >
					</div>
				</div>

				<div class="p-col-12 p-md-4">
					<div class="p-col-12">
						<label for="fiscalId">Vat Id Number</label>
					</div>
					<div class="p-col-12" style="margin-bottom:10px">
						<input type="text" id="vatIdNumber" pInputText placeholder="Vat Id Number"  formControlName="vatIdNumber" >
					</div>
				</div>

				<div class="p-col-12">
					<div class="p-col-12">
						<label for="content">Content</label>
					</div>
					<div class="p-col-12" style="margin-bottom:10px">
						<textarea id="content" pInputTextarea placeholder="Content"  rows="8" cols="75" formControlName="content"></textarea>
					</div>
					<div class="p-col-12" style="margin-bottom:10px">
						<small class="validation-error" *ngIf="content.invalid && (content.dirty || content.touched)">Content is required.</small>
					</div>
				</div>
			</div>
		</div>

		<p-footer>
			<button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" type="submit" disabled [disabled]="!templateForm.valid"></button>
			<button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" type="button" (click)="hideDialog()"></button>
		</p-footer>
	</form>
</p-dialog>

<p-confirmDialog [style]="{width: '500px'}"></p-confirmDialog>
